import axios from "axios";
const urlBaseQrcodeReader = "https://leitor-qrcode-api.sistemasinteegra.com.br";

async function existsInEvent(eventId, loginId) {
  const config = {
    method: "get",
    url: `${urlBaseQrcodeReader}/login-event/${eventId}/event/${loginId}/participant`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response ? error.response.data : { message: "ERROR" };
    });
}

export { existsInEvent };
